import { ref, onMounted, onUnmounted } from "vue";

export function useNetworkStatus() {
  const isOnline = ref(navigator.onLine);
  const connectionType = ref<string>("unknown");

  const updateOnlineStatus = () => {
    isOnline.value = navigator.onLine;
  };

  const updateConnectionInfo = () => {
    // @ts-ignore - Connection API is not fully supported in TypeScript
    const connection =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;
    if (connection) {
      connectionType.value = connection.effectiveType || "unknown";
    }
  };

  onMounted(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    updateConnectionInfo();

    // @ts-ignore - Connection API
    if ((navigator as any).connection) {
      // @ts-ignore
      (navigator as any).connection.addEventListener("change", updateConnectionInfo);
    }
  });

  onUnmounted(() => {
    window.removeEventListener("online", updateOnlineStatus);
    window.removeEventListener("offline", updateOnlineStatus);

    // @ts-ignore - Connection API
    if ((navigator as any).connection) {
      // @ts-ignore
      (navigator as any).connection.removeEventListener("change", updateConnectionInfo);
    }
  });

  return {
    isOnline,
    connectionType,
  };
}
